if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

//年齢確認
document.addEventListener('DOMContentLoaded', function() {
  const ageVerification = document.getElementById('age-verification');
  const birthYearSelect = document.getElementById('birth-year');
  const birthMonthSelect = document.getElementById('birth-month');
  const birthDaySelect = document.getElementById('birth-day');
  const birthdateSubmit = document.getElementById('birthdate-submit');
  const ageError = document.getElementById('age-verification-error');
  const productFormButtons = document.querySelector('.product-form__buttons');

  // 年の選択肢を生成
  for (let year = 1920; year <= 2024; year++) {
    const option = document.createElement('option');
    option.value = year;
    option.text = year;
    birthYearSelect.appendChild(option);
  }

  // デフォルトの年を2000年に設定
  birthYearSelect.value = 2000;

  // 月の選択肢を生成
  for (let month = 1; month <= 12; month++) {
    const option = document.createElement('option');
    option.value = month;
    option.text = month;
    birthMonthSelect.appendChild(option);
  }

  // 日の選択肢を生成
  const updateDays = () => {
    const selectedYear = parseInt(birthYearSelect.value);
    const selectedMonth = parseInt(birthMonthSelect.value);
    const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
    
    birthDaySelect.innerHTML = ''; // 既存の選択肢をクリア
    
    for (let day = 1; day <= daysInMonth; day++) {
      const option = document.createElement('option');
      option.value = day;
      option.text = day;
      birthDaySelect.appendChild(option);
    }
  };

  birthYearSelect.addEventListener('change', updateDays);
  birthMonthSelect.addEventListener('change', updateDays);

  // 初期化時に日を設定
  updateDays();

  if (ageVerification) {
    birthdateSubmit.addEventListener('click', function() {
      // エラーメッセージをリセット
      ageError.style.display = 'none';

      const year = parseInt(birthYearSelect.value);
      const month = parseInt(birthMonthSelect.value) - 1; // JavaScriptの月は0-11
      const day = parseInt(birthDaySelect.value);

      const birthDate = new Date(year, month, day);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      if (age >= 18) {
        ageVerification.style.display = 'none';
        productFormButtons.style.display = 'block';
      } else {
        ageError.textContent = '18歳未満のため購入できません。';
        ageError.style.display = 'block';
      }
    });
  }
});
